export const ROUTES = {
  PRE_LOGIN: {
    LIFEGUARD: "/salvavidas/pre-login",
  },
  AGREEMENT: {
    LIFEGUARD: "/salvavidas/acuerdo-de-datos",
  },
  LOGIN: {
    LIFEGUARD: "/salvavidas/login",
    ADMINISTRATOR: "/administrador/login",
  },
  DASHBOARD: {
    LIFEGUARD: "/salvavidas/dashboard",
    ADMINISTRATOR: "/administrador/dashboard",
  },
  SWIMMERS: {
    REGISTER: "/salvavidas/banistas/registrar",
    REGISTER_WITH_SWIMMER: (swimmerId: string) =>
      `/salvavidas/banistas/registrar/${swimmerId}`,
    /** Edit swimmer: admin dashboard */
    EDIT: (swimmerId: string) => `/administrador/banistas/${swimmerId}/editar`,
    /** Delete swimmer: admin dashboard */
    DELETE: (swimmerId: string) => `/administrador/banistas/${swimmerId}/eliminar`,
    /** Edit swimmer: lifeguard dashboard */
    EDIT_LIFEGUARD: (swimmerId: string) =>
      `/salvavidas/banistas/${swimmerId}/editar`,
  },
  NEWS: {
    REGISTER: "/salvavidas/novedades/registrar",
    REGISTER_WITH_SWIMMER: (swimmerId: string) =>
      `/salvavidas/novedades/registrar/${swimmerId}`,
    NEW_DETAIL: (newId: string) => `/salvavidas/novedades/${newId}`,
    /** Admin-only: edit an existing new (novedad) */
    EDIT: (newId: string) => `/administrador/novedades/${newId}/editar`,
  },
  REPORTS: "/administrador/reportes",
};
